import * as React from "react";

type Props = {
  name: string;
  register?: any;
  value?: any;
  children?: any;
  defaultChecked?:boolean;
  checked?:boolean;
  onChange?: (e: any) => void;
};

export default function Textarea({ name, children, register,defaultChecked,onChange, value,checked }: Props) {
  return (
    <label className="custom-checkbox-container mb-0">
      {children}
      <input type="checkbox" name={name} ref={register} onChange={onChange} defaultChecked={defaultChecked} value={value} checked={checked}/>
      <span className="checkmark"></span>
    </label>
  );
}
